module.exports = __webpack_public_path__ + "static/media/Recipe.ae0b9330.svg";